/* Shopify-rendered product suggestions; plain GET search remains the fallback. */
if (!customElements.get('ss-header-predictive')) {
  customElements.define('ss-header-predictive', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const events = { signal: this.events.signal };
      this.input = this.querySelector('input[name="q"]');
      this.form = this.querySelector('form');
      this.popup = this.querySelector('.ss-search-popup');
      this.list = this.querySelector('[role="listbox"]');
      this.status = this.querySelector('[role="status"]');
      this.sequence = 0;
      this.active = -1;
      this.input.addEventListener('input', () => this.queue(), events);
      this.input.addEventListener('focus', () => this.queue(), events);
      this.addEventListener('keydown', event => this.key(event), events);
      this.popup.addEventListener('mousedown', event => {
        if (event.button === 0 && event.target.closest('a, button')) event.preventDefault();
      }, events);
      this.addEventListener('focusout', event => {
        if (this.contains(event.relatedTarget)) return;
        clearTimeout(this.focusTimer);
        this.focusTimer = setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        }, 0);
      }, events);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.close();
      }, events);
      this.form.addEventListener('submit', () => this.close(), events);
      this.querySelector('.ss-search-all').addEventListener('click', () => this.form.requestSubmit(), events);
    }
    close() {
      clearTimeout(this.timer);
      clearTimeout(this.focusTimer);
      this.request?.abort();
      this.sequence++;
      this.popup.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.active = -1;
    }
    queue() {
      this.close();
      const term = this.input.value.trim();
      if (term.length < 2) return;
      const sequence = this.sequence;
      this.timer = setTimeout(() => this.search(term, sequence), 220);
    }
    async search(term, sequence) {
      if (sequence !== this.sequence || document.activeElement !== this.input) return;
      this.list.replaceChildren();
      this.status.textContent = this.dataset.loading;
      this.popup.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.request = new AbortController();
      try {
        const url = new URL(this.dataset.url, location.origin);
        url.search = new URLSearchParams({q: term, 'resources[type]': 'product', 'resources[limit]': '5', section_id: 'ss-header-suggestions'});
        const response = await fetch(url, { signal: this.request.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Suggestions unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (sequence !== this.sequence || document.activeElement !== this.input) return;
        const options = doc.querySelector('[data-ss-options]');
        const status = doc.querySelector('[data-ss-status]');
        if (!options || !status) throw new Error('Invalid suggestions');
        this.list.replaceChildren(...Array.from(options.children));
        this.options().forEach((option, index) => { option.id = this.list.id + '-' + index; });
        this.status.textContent = status.textContent;
      } catch (error) {
        if (error.name === 'AbortError' || sequence !== this.sequence) return;
        this.status.textContent = this.dataset.failure;
      }
    }
    options() { return Array.from(this.list.querySelectorAll('[role="option"]')); }
    key(event) {
      if (event.key === 'Escape') { this.close(); return; }
      if (event.target !== this.input || this.popup.hidden) return;
      const options = this.options();
      if (event.key === 'Enter' && this.active >= 0 && options[this.active]) {
        event.preventDefault(); options[this.active].click(); return;
      }
      if (!['ArrowDown', 'ArrowUp'].includes(event.key) || !options.length) return;
      event.preventDefault();
      this.active = event.key === 'ArrowDown' ? (this.active + 1) % options.length : (this.active <= 0 ? options.length - 1 : this.active - 1);
      options.forEach((option, index) => option.setAttribute('aria-selected', String(index === this.active)));
      this.input.setAttribute('aria-activedescendant', options[this.active].id);
      options[this.active].scrollIntoView({block:'nearest'});
    }
    disconnectedCallback() { this.close(); this.events?.abort(); this.events = null; }
  });
}
